const replaceIryaminiDesktop = setInterval(() => {
  const headerLabel = document.querySelector(
    'a[href="/collections/iryamini"] .label'
  );

  if (headerLabel && !headerLabel.querySelector("img")) {
    const img = document.createElement("img");
    img.src =
      "https://cdn.shopify.com/s/files/1/0564/0539/3510/files/iryamini2024LOGO_3a3a7d34-2ffa-4832-a1b4-a592652a861e.png?v=1729385637";
    img.alt = "İryamini";
    img.style.maxHeight = "60px";
    img.style.display = "block";

    headerLabel.textContent = "";
    headerLabel.appendChild(img);

    const headerMenuItem = headerLabel.closest("a");
    if (headerMenuItem) {
      headerMenuItem.style.height = "45px";
      headerMenuItem.style.display = "flex";
      headerMenuItem.style.alignItems = "center";
    }

    clearInterval(replaceIryaminiDesktop);
  }
}, 300);

function replaceIryaminiDrawer() {
  const drawerItems = document.querySelectorAll(
    ".menu-drawer__menu-item.list-menu__item.animate-arrow.focus-inset"
  );

  drawerItems.forEach((item) => {
    if (item.textContent.trim().startsWith("İryamini")) {
      const svgs = item.querySelectorAll("svg");
      item.textContent = "";

      const img = document.createElement("img");
      img.src =
        "https://cdn.shopify.com/s/files/1/0564/0539/3510/files/iryamini2024LOGO_3a3a7d34-2ffa-4832-a1b4-a592652a861e.png?v=1729385637";
      img.alt = "İryamini";
      img.style.maxHeight = "45px";
      img.style.display = "inline-block";
      img.style.verticalAlign = "middle";

      item.appendChild(img);
      svgs.forEach((svg) => item.appendChild(svg));

      item.style.height = "53px";
      item.style.display = "flex";
      item.style.alignItems = "center";
    }
  });
}

const body = document.querySelector("body");
const observer = new MutationObserver(() => {
  if (body.classList.contains("menu-mobile--open")) {
    setTimeout(replaceIryaminiDrawer, 100);
  }
});
observer.observe(body, { attributes: true, attributeFilter: ["class"] });
